import { FC } from 'react';
// import * as Dialog from '@radix-ui/react-dialog';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@features/ui';
import { TOption } from '@src/types';

interface ViewAccountPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  productOptions: TOption[];
}
export const ViewAccountPopup: FC<ViewAccountPopupProps> = ({
  open,
  onOpenChange,
  productOptions,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader className="mb-5">
          <DialogTitle className="text-2xl text-center mb-[23px]">
            View Accounts
          </DialogTitle>
          {productOptions.length ? (
            productOptions.map((item) => (
              <div key={item.value}>
                <DialogDescription className="text-white text-[16px] flex items-center gap-2">
                  <div className="h-1.5 w-1.5 rounded-full bg-white" />
                  {item.label}
                </DialogDescription>
              </div>
            ))
          ) : (
            <DialogDescription className="text-white text-[16px] text-center">
              No accounts found.
            </DialogDescription>
          )}
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
